<template>
  <div class="studentCard">
    <div class="sc_header">
      <div class="sc_h_left">
        <el-select
          v-model="selectSort"
          @change="changeSelect"
          style="width: 110px; margin-right: 10px"
        >
          <el-option
            v-for="item in selectSortList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>

        <el-select
          v-model="selectGrouping"
          @change="changeSelect"
          style="width: 110px; margin-right: 10px"
        >
          <el-option
            v-for="item in selectGroupingList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>

        <el-select
          v-model="selectClass"
          @change="changeSelect"
          style="width: 120px; margin-right: 10px"
        >
          <el-option
            v-for="item in selectClassList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>

        <el-input
          class="sc_h_l_input"
          v-model="searchValue"
          :placeholder="lang.search_for_students_names"
          @keyup.enter.native="changeSelect"
          clearable
          @input="changeSelect"
        >
          <!-- <i
						slot="suffix"
						style="font-size: 20px; cursor: pointer"
						@click="changeSelect"
						class="el-input__icon el-icon-search"
					></i> -->
        </el-input>
      </div>
      <div class="sc_h_right">
        <div
          @click="setCountDown()"
          :style="`color:${
            countDownTimeValue ? '#fff' : '#000'
          };background-color:${countDownTimeValue ? '#0354D7' : '#fff'}`"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            :fill="countDownTimeValue ? '#fff' : '#969BA3'"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="fluent:clock-alarm-24-regular">
              <path
                id="Vector"
                d="M10 6.45827C10 6.29251 9.93415 6.13354 9.81694 6.01633C9.69973 5.89912 9.54076 5.83327 9.375 5.83327C9.20924 5.83327 9.05026 5.89912 8.93305 6.01633C8.81584 6.13354 8.75 6.29251 8.75 6.45827V10.6249C8.75 10.9699 9.03 11.2499 9.375 11.2499H12.2917C12.4574 11.2499 12.6164 11.1841 12.7336 11.0669C12.8508 10.9497 12.9167 10.7907 12.9167 10.6249C12.9167 10.4592 12.8508 10.3002 12.7336 10.183C12.6164 10.0658 12.4574 9.99993 12.2917 9.99993H10V6.45827ZM2.89666 7.58577C2.53463 7.29143 2.23842 6.92437 2.02719 6.50834C1.81597 6.0923 1.69445 5.63655 1.67048 5.17058C1.64651 4.70461 1.72063 4.2388 1.88805 3.80328C2.05547 3.36777 2.31246 2.97225 2.64239 2.64233C2.97231 2.3124 3.36783 2.05541 3.80334 1.88799C4.23886 1.72057 4.70467 1.64645 5.17064 1.67042C5.63661 1.69438 6.09236 1.81591 6.5084 2.02713C6.92443 2.23835 7.2915 2.53457 7.58583 2.8966C8.36342 2.63313 9.17899 2.49913 10 2.49993C10.821 2.49913 11.6366 2.63313 12.4142 2.8966C12.7085 2.53457 13.0756 2.23835 13.4916 2.02713C13.9076 1.81591 14.3634 1.69438 14.8294 1.67042C15.2953 1.64645 15.7611 1.72057 16.1966 1.88799C16.6322 2.05541 17.0277 2.3124 17.3576 2.64233C17.6875 2.97225 17.9445 3.36777 18.1119 3.80328C18.2794 4.2388 18.3535 4.70461 18.3295 5.17058C18.3055 5.63655 18.184 6.0923 17.9728 6.50834C17.7616 6.92437 17.4654 7.29143 17.1033 7.58577C17.3668 8.36335 17.5008 9.17893 17.5 9.99993C17.5 11.8458 16.8333 13.5366 15.7267 14.8433L17.3167 16.4333C17.3781 16.4905 17.4273 16.5595 17.4615 16.6362C17.4956 16.7128 17.514 16.7956 17.5155 16.8795C17.517 16.9634 17.5015 17.0468 17.4701 17.1246C17.4387 17.2024 17.3919 17.2731 17.3325 17.3325C17.2732 17.3918 17.2025 17.4386 17.1247 17.47C17.0468 17.5015 16.9635 17.5169 16.8796 17.5154C16.7956 17.5139 16.7129 17.4956 16.6362 17.4614C16.5595 17.4273 16.4905 17.378 16.4333 17.3166L14.8433 15.7266C13.4908 16.8743 11.7738 17.5029 10 17.4999C8.15416 17.4999 6.46333 16.8333 5.15666 15.7266L3.56666 17.3166C3.44818 17.427 3.29148 17.4871 3.12956 17.4842C2.96764 17.4814 2.81316 17.4158 2.69864 17.3013C2.58413 17.1868 2.51854 17.0323 2.51568 16.8704C2.51283 16.7085 2.57293 16.5517 2.68333 16.4333L4.27333 14.8433C3.12567 13.4907 2.49703 11.7738 2.5 9.99993C2.5 9.15577 2.63916 8.34327 2.89666 7.58577ZM2.91666 4.99993C2.91666 5.52577 3.11166 6.0066 3.43333 6.37327C4.11813 5.13688 5.13694 4.11807 6.37333 3.43327C6.07223 3.16932 5.70145 2.99773 5.30537 2.93904C4.90928 2.88034 4.50467 2.93704 4.13997 3.10233C3.77527 3.26763 3.46593 3.53451 3.24898 3.87105C3.03203 4.20759 2.91665 4.59953 2.91666 4.99993ZM16.5667 6.37327C16.9155 5.9756 17.1 5.46011 17.0828 4.93138C17.0655 4.40266 16.8477 3.90031 16.4737 3.52625C16.0996 3.15219 15.5973 2.93443 15.0685 2.91716C14.5398 2.8999 14.0243 3.08441 13.6267 3.43327C14.8631 4.11807 15.8819 5.13688 16.5667 6.37327ZM3.75 9.99993C3.75 11.6575 4.40848 13.2472 5.58058 14.4194C6.75268 15.5915 8.34239 16.2499 10 16.2499C11.6576 16.2499 13.2473 15.5915 14.4194 14.4194C15.5915 13.2472 16.25 11.6575 16.25 9.99993C16.25 8.34233 15.5915 6.75262 14.4194 5.58052C13.2473 4.40842 11.6576 3.74993 10 3.74993C8.34239 3.74993 6.75268 4.40842 5.58058 5.58052C4.40848 6.75262 3.75 8.34233 3.75 9.99993Z"
              />
            </g>
          </svg>

          <span
            >{{ lang.Timer }}
            <span v-if="countDownTimeValue">{{
              countDownTimeValue
            }}</span></span
          >
        </div>
        <div @click="sendMessage()">
          <svg
            class="messageSvg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            stroke="#969BA3"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <g id="tabler:message">
              <path
                id="Vector"
                d="M6.66667 7.49992H13.3333M6.66667 10.8333H11.6667M15 3.33325C15.663 3.33325 16.2989 3.59664 16.7678 4.06549C17.2366 4.53433 17.5 5.17021 17.5 5.83325V12.4999C17.5 13.163 17.2366 13.7988 16.7678 14.2677C16.2989 14.7365 15.663 14.9999 15 14.9999H10.8333L6.66667 17.4999V14.9999H5C4.33696 14.9999 3.70107 14.7365 3.23223 14.2677C2.76339 13.7988 2.5 13.163 2.5 12.4999V5.83325C2.5 5.17021 2.76339 4.53433 3.23223 4.06549C3.70107 3.59664 4.33696 3.33325 5 3.33325H15Z"
              />
            </g>
          </svg>

          <span>{{ lang.all_staff_message }}</span>
        </div>
      </div>
    </div>
    <div class="sc_tableArea">
      <div class="sc_ta_header">
        <div class="sc_ta_h_item">
          <span>{{ lang.student_name }}</span>
          <span>
            <span>{{ lang.summary }}</span>
            <img src="../../../assets/img/teachingMode/refresh.svg" alt="" @click="smartSummaryList()">
          </span>
          <span style="width: 300px">{{ lang.node }}</span>
          <span>{{ lang.last_conversation }}</span>
          <span v-if="!['agent'].includes(obj.label)">{{
            lang.task_status
          }}</span>
          <span v-if="isShowTest">{{ lang.diagnosisReport }}</span>
          <span>{{ lang.operate }}</span>
        </div>
      </div>
      <div class="sc_ta_box" v-loading="loading || getGroupListLoading">
        <div
          class="sc_ta_b_item"
          v-for="(item, index) in studentList"
          :key="item.id + '_' + index"
          v-loading="item.id == changeLoading"
          v-show="groupStudentList.length <= 0"
        >
          <div>
            <div @click="openStudentAllMessageDialog(item.id)">
              <!-- <span :class="`status_${item.operating} status`"></span> -->
              <div>{{ item.name }}</div>
              <div class="nodeStage">
                <!-- <span
									v-for="(task, index) in item.stage"
									:key="index"
									:class="{ ns_active: item.nodeData.length > index }"
								></span> -->
              </div>
            </div>
            <div v-loading="smartSummaryLoadingList.includes(item.id)">
              <el-tooltip
                class="item"
                effect="light"
                :content="item.summary"
                placement="top"
              >
                <span class="summaryText">
                  {{ item.summary ? item.summary : "-" }}
                </span>
              </el-tooltip>
            </div>
            <div style="width: 300px">
              <div
                class="nodeArea"
                v-if="item.nodeData && item.nodeData.length > 0"
              >
                <el-popover
                  v-for="(na, index) in item.nodeData"
                  :key="na.nodeId"
                  placement="right"
                  trigger="hover"
                  popper-class="nodePopover"
                >
                  <div class="na_message">
                    <template>
                      <div v-for="(m, mIndex) in na.messageList" :key="m.uid + '_' + mIndex">
                        <div v-if="m.userContent" class="na_m_item">
                          <div class="na_m_i_name">
                            {{ m.userName }}
                          </div>
                          <div
                            class="na_m_i_content"
                            v-html="m.userContent"
                          ></div>
                        </div>

                        <div class="na_m_item" v-if="m.aiContent">
                          <div class="na_m_i_name aiName">
                            {{ m.aiName }}
                          </div>
                          <div
                            class="na_m_i_content"
                            v-html="mdToHtml(m.aiContent)"
                          ></div>
                        </div>
                      </div>
                    </template>
                  </div>
                  <div
                    class="na_item"
                    slot="reference"
                    @click="openStudentDialog(item.id, index)"
                    :class="{ nodeBar: item.nodeData.length - 1 > index }"
                  >
                    <span>{{
                      index + 1 < 10 ? "0" + (index + 1) : index + 1
                    }}</span>
                    <img
                      v-if="na.status == '0'"
                      src="@/assets/img/teachingMode/good.svg"
                    />
                    <img
                      v-else-if="na.status == '1'"
                      src="@/assets/img/teachingMode/bad.svg"
                    />
                    <img
                      v-else-if="na.status == '2'"
                      src="@/assets/img/teachingMode/default.svg"
                    />
                  </div>
                </el-popover>
              </div>
              <span v-else>-</span>
            </div>
            <div>
              <span>{{
                item.lastChat
                  ? new Date(item.lastChat)
                      .toLocaleString("zh-CN")
                      .replaceAll("/", "-")
                  : "-"
              }}</span>
            </div>
            <div v-if="!['agent'].includes(obj.label)">
              <div :class="`taskStatus_${item.status} taskStatus`">
                {{ statusList[item.status] }}
              </div>
            </div>
            <div v-if="isShowTest">
              <template v-if="showDiagnosisReport(item)">
                <el-popover
                  placement="right"
                  trigger="hover"
                  popper-class="nodePopover"
                >
                  <div class="na_message">
                    <template>
                      <div v-for="(m, mIndex) in getLatestNode(item).messageList" :key="m.uid + '_' + mIndex">
                        <div v-if="m.userContent" class="na_m_item">
                          <div class="na_m_i_name">
                            {{ m.userName }}
                          </div>
                          <div
                            class="na_m_i_content"
                            v-html="m.userContent"
                          ></div>
                        </div>
                        <div class="na_m_item" v-if="m.aiContent">
                          <div class="na_m_i_name aiName">
                            {{ m.aiName }}
                          </div>
                          <div
                            class="na_m_i_content"
                            v-html="mdToHtml(m.aiContent)"
                          ></div>
                        </div>
                      </div>
                    </template>
                  </div>
                  <div
                    class="diagnosis-report-icon"
                    slot="reference"
                    @click="
                      openStudentDialog(item.id, item.nodeData.length - 1)
                    "
                  >
                    <i
                      class="el-icon-document"
                      style="
                        font-size: 40px;
                        line-height: 60px;
                        width: 40px;
                        height: 60px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    ></i>
                  </div>
                </el-popover>
              </template>
              <span v-else>
                <i
                  class="el-icon-document"
                  style="
                    color: #969ba3;
                    font-size: 40px;
                    line-height: 60px;
                    width: 40px;
                    height: 60px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                ></i>
              </span>
            </div>
            <div class="operationBtn">
              <el-popover
                placement="bottom-end"
                trigger="click"
                popper-class="teachingModePopover "
              >
                <div class="teachingModePopoverArea">
                  <div
                    class="teachingModePopoverAreaBtn"
                    @click.stop="pauseStudent(item.id)"
                    v-if="item.status == '0'"
                  >
                    {{ lang.pause }}
                  </div>
                  <div
                    class="teachingModePopoverAreaBtn"
                    @click.stop="startStudent(item.id)"
                    v-if="item.status == '2'"
                  >
                    {{ lang.continue }}
                  </div>
                  <!-- <div
										class="teachingModePopoverAreaBtn"
										@click.stop="stopStudent(item.id)"
										v-if="['0', '1', '2'].includes(item.status)"
									>
										{{ lang.end }}
									</div> -->

                  <div
                    class="teachingModePopoverAreaBtn"
                    @click.stop="delStudent(item.id)"
                  >
                    {{ lang.remove }}
                  </div>

                  <div
                    class="teachingModePopoverAreaBtn"
                    @click.stop="resetStudent(item.id)"
                  >
                    {{ lang.restart }}
                  </div>
                  <div
                    class="teachingModePopoverAreaBtn"
                    @click.stop="sendMessage(item.id)"
                  >
                    {{ lang.send_a_message }}
                  </div>

                  <div
                    v-if="
                      (!['agent'].includes(obj.label) && item.status == '1') ||
                      ['agent'].includes(obj.label)
                    "
                    class="teachingModePopoverAreaBtn"
                    @click.stop="smartSummary(item)"
                  >
                    {{ lang.smartSummary }}
                  </div>
                </div>
                <svg
                  t="1732786015570"
                  slot="reference"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="9199"
                  width="200"
                  fill="rgba(150, 155, 163, 1)"
                  height="200"
                >
                  <path
                    d="M192 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-29.866667-68.266667-68.266667-68.266667zM512 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-29.866667-68.266667-68.266667-68.266667zM832 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-34.133333-68.266667-68.266667-68.266667z"
                    p-id="9200"
                  ></path>
                </svg>
              </el-popover>
            </div>
          </div>
        </div>
        <div
          v-show="groupStudentList.length > 0 && group.list.length > 0"
          v-for="(group, groupIndex) in groupStudentList"
          :key="groupIndex"
        >
          <div class="groupHead" style="border-bottom: solid 1px #e7e7e7">
            <div
              class="gh_name"
              :style="`background-color:${group.bgColor};color:${group.color};border:solid 1px ${group.borderColor};border-bottom:none;`"
            >
              {{ group.groupName }}
            </div>

            <div class="messageBtn" @click="sendMessageToGroup(group.list)">
              <svg
                class="messageSvg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                stroke="#969BA3"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <g id="tabler:message">
                  <path
                    id="Vector"
                    d="M6.66667 7.49992H13.3333M6.66667 10.8333H11.6667M15 3.33325C15.663 3.33325 16.2989 3.59664 16.7678 4.06549C17.2366 4.53433 17.5 5.17021 17.5 5.83325V12.4999C17.5 13.163 17.2366 13.7988 16.7678 14.2677C16.2989 14.7365 15.663 14.9999 15 14.9999H10.8333L6.66667 17.4999V14.9999H5C4.33696 14.9999 3.70107 14.7365 3.23223 14.2677C2.76339 13.7988 2.5 13.163 2.5 12.4999V5.83325C2.5 5.17021 2.76339 4.53433 3.23223 4.06549C3.70107 3.59664 4.33696 3.33325 5 3.33325H15Z"
                  />
                </g>
              </svg>

              <span>{{ lang.groupMessage }}</span>
              <!-- <svg t="1755831768395" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5260" width="200" height="200"><path d="M821.333333 800H547.584l-86.464 96.074667a32 32 0 1 1-47.573333-42.816l96-106.666667A32 32 0 0 1 533.333333 736h288a53.333333 53.333333 0 0 0 53.333334-53.333333V234.666667a53.333333 53.333333 0 0 0-53.333334-53.333334H202.666667a53.333333 53.333333 0 0 0-53.333334 53.333334v448a53.333333 53.333333 0 0 0 53.333334 53.333333h138.666666a32 32 0 0 1 0 64H202.666667c-64.8 0-117.333333-52.533333-117.333334-117.333333V234.666667c0-64.8 52.533333-117.333333 117.333334-117.333334h618.666666c64.8 0 117.333333 52.533333 117.333334 117.333334v448c0 64.8-52.533333 117.333333-117.333334 117.333333zM704 341.333333a32 32 0 0 1 0 64H320a32 32 0 0 1 0-64h384zM512 512a32 32 0 0 1 0 64H320a32 32 0 0 1 0-64h192z" fill="#000000" p-id="5261"></path></svg> -->
            </div>
          </div>
          <div class="groupList">
            <div
              class="sc_ta_b_item"
              v-for="(item, index) in group.list"
              :key="item.id + '_' + index"
              v-loading="item.id == changeLoading"
            >
              <div>
                <div @click="openStudentAllMessageDialog(item.id)">
                  <!--<span :class="`status_${item.operating} status`"></span>-->
                  <div>{{ item.name }}</div>
                  <div class="nodeStage">
                    <!-- <span
									v-for="(task, index) in item.stage"
									:key="index"
									:class="{ ns_active: item.nodeData.length > index }"
								></span> -->
                  </div>
                </div>
                <div v-loading="smartSummaryLoadingList.includes(item.id)">
                  <el-tooltip
                    class="item"
                    effect="light"
                    :content="item.summary"
                    placement="top"
                  >
                    <span class="summaryText">
                      {{ item.summary ? item.summary : "-" }}
                    </span></el-tooltip
                  >
                </div>
                <div style="width: 300px">
                  <div
                    class="nodeArea"
                    v-if="item.nodeData && item.nodeData.length > 0"
                  >
                    <el-popover
                      v-for="(na, index) in item.nodeData"
                      :key="na.nodeId"
                      placement="right"
                      trigger="hover"
                      popper-class="nodePopover"
                    >
                      <div class="na_message">
                        <template>
                          <div v-for="(m, mIndex) in na.messageList" :key="m.uid + '_' + mIndex">
                            <div v-if="m.userContent" class="na_m_item">
                              <div class="na_m_i_name">
                                {{ m.userName }}
                              </div>
                              <div
                                class="na_m_i_content"
                                v-html="m.userContent"
                              ></div>
                            </div>

                            <div class="na_m_item" v-if="m.aiContent">
                              <div class="na_m_i_name aiName">
                                {{ m.aiName }}
                              </div>
                              <div
                                class="na_m_i_content"
                                v-html="mdToHtml(m.aiContent)"
                              ></div>
                            </div>
                          </div>
                        </template>
                      </div>
                      <div
                        class="na_item"
                        slot="reference"
                        @click="openStudentDialog(item.id, index)"
                        :class="{ nodeBar: item.nodeData.length - 1 > index }"
                      >
                        <span>{{
                          index + 1 < 10 ? "0" + (index + 1) : index + 1
                        }}</span>
                        <img
                          v-if="na.status == '0'"
                          src="@/assets/img/teachingMode/good.svg"
                        />
                        <img
                          v-else-if="na.status == '1'"
                          src="@/assets/img/teachingMode/bad.svg"
                        />
                        <img
                          v-else-if="na.status == '2'"
                          src="@/assets/img/teachingMode/default.svg"
                        />
                      </div>
                    </el-popover>
                  </div>
                  <span v-else>-</span>
                </div>
                <div>
                  <span>{{
                    item.lastChat
                      ? new Date(item.lastChat)
                          .toLocaleString("zh-CN")
                          .replaceAll("/", "-")
                      : "-"
                  }}</span>
                </div>
                <div v-if="!['agent'].includes(obj.label)">
                  <div :class="`taskStatus_${item.status} taskStatus`">
                    {{ statusList[item.status] }}
                  </div>
                </div>
                <div v-if="isShowTest">
                  <template v-if="showDiagnosisReport(item)">
                    <el-popover
                      placement="right"
                      trigger="hover"
                      popper-class="nodePopover"
                    >
                      <div class="na_message">
                        <template>
                          <div v-for="(m, mIndex) in getLatestNode(item).messageList" :key="m.uid + '_' + mIndex">
                            <div v-if="m.userContent" class="na_m_item">
                              <div class="na_m_i_name">
                                {{ m.userName }}
                              </div>
                              <div
                                class="na_m_i_content"
                                v-html="m.userContent"
                              ></div>
                            </div>
                            <div class="na_m_item" v-if="m.aiContent">
                              <div class="na_m_i_name aiName">
                                {{ m.aiName }}
                              </div>
                              <div
                                class="na_m_i_content"
                                v-html="mdToHtml(m.aiContent)"
                              ></div>
                            </div>
                          </div>
                        </template>
                      </div>
                      <div
                        class="diagnosis-report-icon"
                        slot="reference"
                        @click="
                          openStudentDialog(item.id, item.nodeData.length - 1)
                        "
                      >
                        <i
                          class="el-icon-document"
                          style="
                            font-size: 40px;
                            line-height: 60px;
                            width: 40px;
                            height: 60px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                          "
                        ></i>
                      </div>
                    </el-popover>
                  </template>
                  <span v-else>
                    <i
                      class="el-icon-document"
                      style="
                        color: #969ba3;
                        font-size: 40px;
                        line-height: 60px;
                        width: 40px;
                        height: 60px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    ></i>
                  </span>
                </div>
                <div class="operationBtn">
                  <el-popover
                    placement="bottom-end"
                    trigger="click"
                    popper-class="teachingModePopover "
                  >
                    <div class="teachingModePopoverArea">
                      <div
                        class="teachingModePopoverAreaBtn"
                        @click.stop="pauseStudent(item.id)"
                        v-if="item.status == '0'"
                      >
                        {{ lang.pause }}
                      </div>
                      <div
                        class="teachingModePopoverAreaBtn"
                        @click.stop="startStudent(item.id)"
                        v-if="item.status == '2'"
                      >
                        {{ lang.enable }}
                      </div>
                      <!-- <div
												class="teachingModePopoverAreaBtn"
												@click.stop="stopStudent(item.id)"
												v-if="['0', '1', '2'].includes(item.status)"
											>
												{{ lang.end }}
											</div> -->

                      <div
                        class="teachingModePopoverAreaBtn"
                        @click.stop="delStudent(item.id)"
                      >
                        {{ lang.remove }}
                      </div>

                      <div
                        class="teachingModePopoverAreaBtn"
                        @click.stop="resetStudent(item.id)"
                      >
                        {{ lang.restart }}
                      </div>
                      <div
                        class="teachingModePopoverAreaBtn"
                        @click.stop="sendMessage(item.id)"
                      >
                        {{ lang.send_a_message }}
                      </div>
                      <div
                        v-if="
                          (!['agent'].includes(obj.label) &&
                            item.status == '1') ||
                          ['agent'].includes(obj.label)
                        "
                        class="teachingModePopoverAreaBtn"
                        @click.stop="smartSummary(item)"
                      >
                        {{ lang.smartSummary }}
                      </div>
                    </div>
                    <svg
                      t="1732786015570"
                      slot="reference"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="9199"
                      width="200"
                      fill="rgba(150, 155, 163, 1)"
                      height="200"
                    >
                      <path
                        d="M192 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-29.866667-68.266667-68.266667-68.266667zM512 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-29.866667-68.266667-68.266667-68.266667zM832 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-34.133333-68.266667-68.266667-68.266667z"
                        p-id="9200"
                      ></path>
                    </svg>
                  </el-popover>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="studentList.length == 0" class="noData">
          <div class="noDataText">
            {{ lang.noDataAvailable }}...<span
              class="inviteStudent"
              @click="inviteStudent"
              >{{ lang.inviteStudent }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <sendMessageDialog
      ref="sendMessageDialogRef"
      @success="sendMessageSuccess"
    />
    <countdownDialog ref="countdownDialogRef" @success="sendCountDownSuccess" />
    <studentDialogueDataDialog ref="studentDialogueDataDialogRef" />
  </div>
</template>

<script>
import sendMessageDialog from "../dialog/sendMessageDialog.vue";
import countdownDialog from "../dialog/countdownDialog.vue";
import studentDialogueDataDialog from "../dialog/studentDialogueDataDialog.vue";
import { myMixin } from "@/common/mixin";
import MarkdownIt from "markdown-it";

// const md = require('markdown-it')({
//   html: true,
//   linkify: true,
//   typographer: true
// })
export default {
  props: {
    obj: {
      type: Object,
      default: () => {},
    },
    isShowTest: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [myMixin],
  components: {
    sendMessageDialog,
    countdownDialog,
    studentDialogueDataDialog,
  },
  data() {
    return {
      selectSortList: this.lang.selectSortList,
      selectGroupingList: JSON.parse(
        JSON.stringify(this.lang.selectGroupingList)
      ),
      selectClassList: [{ value: "", label: this.lang.all_classes }],
      selectSort: "",
      selectGrouping: "",
      selectClass: "",
      searchValue: "",
      statusList: [
        this.lang.Incomplete,
        this.lang.completed,
        this.lang.pause,
        this.lang.stop,
      ],
      studentList: [],
      copyStudentList: [],
      groupStudentList: [],
      loading: false,
      changeLoading: null,
      getGroupListLoading: false,
      countDownTimeValue: "",
      test: true,
      smartSummaryLoadingList: [],
    };
  },
  watch: {
    obj(newValue) {
      if (newValue.class_id) {
        this.getClassList();
      }

      if (["agent"].includes(newValue.label)) {
        this.selectGroupingList = this.selectGroupingList.filter(
          (i) => i.value !== "0"
        );
        this.selectSortList = this.selectSortList.filter(
          (i) => i.value !== "1"
        );
      }
      // if (newValue.tJson && newValue.tJson.group) {
      // 	console.log("this.obj.tJson.group", newValue.tJson.group);
      // 	if (
      // 		this.selectGroupingList.findIndex(
      // 			(i) => i.value === "aiGroupList"
      // 		) === -1
      // 	) {
      // 		this.selectGroupingList.push({
      // 			value: "aiGroupList",
      // 			label: this.lang.aiGroupList,
      // 			group: newValue.tJson.group,
      // 		});
      // 	} else {
      // 		this.selectGroupingList.find((i) => i.value === "aiGroupList").group =
      // 			newValue.tJson.group;
      // 	}
      // 	// this.selectGrouping = "aiGroupList"
      // 	this.changeSelect();
      // } else {
      // 	this.selectGroupingList = this.lang.selectGroupingList;
      // 	console.log("selectGroupingList", this.selectGroupingList);
      // }
    },
  },
  computed: {
    mdToHtml() {
      return (content) => {
        // 判断是否为 HTML 格式，如果是则直接返回
        if (typeof content === "string" && /<[^>]+>/.test(content.trim())) {
          return content;
        }
        const md = new MarkdownIt();
        return md.render(content);
      };
    },
  },
  methods: {
    async changeSelect() {
      this.studentList = [];
      this.groupStudentList = [];
      let _data = JSON.parse(JSON.stringify(this.copyStudentList));
      if (this.selectSort === "0") {
        // 优化排序：支持名字中带数字的自然排序，且兼容中英文
        _data.sort((a, b) => {
          // 自然排序函数
          function naturalCompare(str1, str2) {
            const reg = /(\d+)|(\D+)/g;
            const arr1 = String(str1).match(reg);
            const arr2 = String(str2).match(reg);
            const len = Math.max(
              arr1 ? arr1.length : 0,
              arr2 ? arr2.length : 0
            );
            for (let i = 0; i < len; i++) {
              const s1 = arr1 && arr1[i] !== undefined ? arr1[i] : "";
              const s2 = arr2 && arr2[i] !== undefined ? arr2[i] : "";
              // 都是数字
              if (!isNaN(s1) && !isNaN(s2)) {
                const diff = parseInt(s1, 10) - parseInt(s2, 10);
                if (diff !== 0) return diff;
              } else if (s1 !== s2) {
                // 中文优先
                return s1.localeCompare(s2, "zh");
              }
            }
            return 0;
          }
          return naturalCompare(a.name, b.name);
        });
      } else if (this.selectSort === "1") {
        _data.sort((a, b) => {
          // 如果a.status为"1"，排最前面
          if (a.status === "1" && b.status !== "1") {
            return -1;
          } else if (a.status !== "1" && b.status === "1") {
            return 1;
          } else {
            return parseInt(a.status) - parseInt(b.status);
          }
        });
        // _data.sort((a, b) => {
        // 	parseInt(a.status) - parseInt(b.status);
        // });
      }

      if (this.selectClass) {
        _data = _data.filter((item) => {
          return item.classid == this.selectClass;
        });
      }

      if (this.searchValue) {
        _data = _data.filter(
          (item) => item.name.indexOf(this.searchValue) !== -1
        );
      }

      if (this.selectGrouping !== "") {
        let groupStudentList = [];
        if (this.selectGrouping === "0") {
          _data.forEach((i) => {
            let _findIndex = groupStudentList.findIndex(
              (j) => j.nodeNum === i.nodeData.length
            );
            if (_findIndex !== -1) {
              groupStudentList[_findIndex].list.push(i);
            } else {
              groupStudentList.push({
                groupName: `${this.lang.node} ${i.nodeData.length}`,
                list: [i],
                bgColor: "#f3f3f3",
                color: "#rgba(0, 0, 0, 0.4)",
                borderColor: "#d5deeb",
                nodeNum: i.nodeData.length,
              });
            }
            groupStudentList.sort((a, b) => b.nodeNum - a.nodeNum);
          });
        } else if (this.selectGrouping === "1") {
          let _group = await this.groupingBtn(_data);
          if (_group) {
            groupStudentList = _group;
          }
          // let _group = JSON.parse(
          // 	JSON.stringify(
          // 		this.selectGroupingList.find((i) => i.value === "aiGroupList")
          // 			.group
          // 	)
          // );
          // console.log("_group", _group);
          // console.log("_data", _data);
          // let _isUseData = [];
          // _group.forEach((i) => {
          // 	i.list.forEach((i2, index2) => {
          // 		let _findIndex = _data.findIndex((i3) => i3.id == i2);
          // 		if (_findIndex != -1) {
          // 			i.list[index2] = _data[_findIndex];
          // 			_isUseData.push(_data[_findIndex].id);
          // 		} else {
          // 			i.list.splice(index2, 1);
          // 		}
          // 	});
          // });
          // if (_isUseData.length < _data.length) {
          // 	let _noUseData = _data.filter((i) => !_isUseData.includes(i.id));
          // 	_group.push({
          // 		groupName: this.lang.noGroup,
          // 		list: _noUseData,
          // 		bgColor: "#f3f3f3",
          // 		borderColor: "#d5deeb",
          // 		color: "rgba(0, 0, 0, 0.4)",
          // 	});
          // }

          // console.log("_group2222", _group);
          // groupStudentList = _group;
        }

        this.groupStudentList = groupStudentList;
      }

      this.studentList = _data;
      this.$forceUpdate();
    },
    //暂停学生
    pauseStudent(id) {
      if (this.changeLoading) return;
      let _index = this.copyStudentList.findIndex((item) => item.id === id);
      this.changeLoading = id;
      let params = [
        {
          uid: id,
          status: "2",
          operating: this.copyStudentList[_index].operating,
        },
      ];

      this.ajax
        .post(
          this.$store.state.api +
            "update_teachingModeWorks_statusAndOperatingById",
          params
        )
        .then((res) => {
          if (res.data == 1) {
            this.$message.success(this.lang.modifiedSuccessfully);
            this.copyStudentList.find((i) => i.id === id).status = "2";
            this.changeSelect();
            this.$emit("sendMessage", { type: "changeTeachingWorks", id: id });
          } else {
            this.$message.error(this.lang.modificationFailure);
          }
          this.changeLoading = null;
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(this.lang.modificationFailure);
          this.changeLoading = null;
        });
      // this.$message.info(`暂停学生${id}`);
    },
    //开启学生
    startStudent(id) {
      if (this.changeLoading) return;
      let _index = this.copyStudentList.findIndex((item) => item.id === id);
      this.changeLoading = id;
      let params = [
        {
          uid: id,
          status: "0",
          operating: this.copyStudentList[_index].operating,
        },
      ];

      this.ajax
        .post(
          this.$store.state.api +
            "update_teachingModeWorks_statusAndOperatingById",
          params
        )
        .then((res) => {
          if (res.data == 1) {
            this.$message.success(this.lang.modifiedSuccessfully);
            this.copyStudentList.find((i) => i.id === id).status = "0";
            this.$emit("sendMessage", { type: "changeTeachingWorks", id: id });
            this.changeSelect();
          } else {
            this.$message.error(this.lang.modificationFailure);
          }
          this.changeLoading = null;
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(this.lang.modificationFailure);
          this.changeLoading = null;
        });
    },
    //停止学生
    stopStudent(id) {
      if (this.changeLoading) return;
      this.$confirm(this.lang.endChatConfirm, this.lang.tip, {
        confirmButtonText: this.lang.queding,
        cancelButtonText: this.lang.cancel,
        type: "warning",
      }).then(() => {
        this.changeLoading = id;
        let _index = this.copyStudentList.findIndex((item) => item.id === id);
        let params = [
          {
            uid: id,
            status: "3",
            operating: this.copyStudentList[_index].operating,
          },
        ];

        this.ajax
          .post(
            this.$store.state.api +
              "update_teachingModeWorks_statusAndOperatingById",
            params
          )
          .then((res) => {
            if (res.data == 1) {
              this.$message.success(this.lang.modifiedSuccessfully);
              this.copyStudentList.find((i) => i.id === id).status = "3";
              this.$emit("sendMessage", {
                type: "changeTeachingWorks",
                id: id,
              });
              this.changeSelect();
            } else {
              this.$message.error(this.lang.modificationFailure);
            }
            this.changeLoading = null;
          })
          .catch((err) => {
            console.log(err);
            this.$message.error(this.lang.modificationFailure);
            this.changeLoading = null;
          });
      });
    },
    //重新开始学生
    resetStudent(id) {
      this.$confirm(this.lang.deleteStudentDataConfirm, this.lang.tips, {
        confirmButtonText: this.lang.queding,
        cancelButtonText: this.lang.cancel,
        type: "warning",
      })
        .then(() => {
          let params = [
            {
              wid: id,
              nodeData: JSON.stringify([]),
              stage: 0,
              lastChat: "",
            },
          ];

          this.ajax
            .post(
              this.$store.state.api +
                "update_teachingModeWorks_nodeDataAndStageAndLastChatById",
              params
            )
            .then((res) => {
              if (res.data == 1) {
                let params2 = [
                  {
                    wid: id,
                    newStatus: "0",
                    newOperating: "0",
                  },
                ];
                this.ajax
                  .post(
                    this.$store.state.api +
                      "update_teachingModeWorks_statusAndOperatingById",
                    params2
                  )
                  .then((res2) => {
                    if (res2.data == 1) {
                      this.ajax
                        .post(
                          this.$store.state.api +
                            "update_teachingModeWorks_summaryById",
                          [{ wid: id, summary: "" }]
                        )
                        .then((res3) => {
                          if (res3.data == 1) {
                            this.$message.success(
                              this.lang.modifiedSuccessfully
                            );
                            this.updateStudentData(id,this.obj.id);
                            this.$emit("sendMessage", {
                              type: "changeTeachingWorks",
                              id: id,
                              msg: "restart",
                            });
                            this.$emit("sendMessage", {
                              type: "restartTeachingWorks",
                              id: id,
                              msg: "restart",
                            });
                          }
                        });
                    }
                  });
              }
            });
        })
        .catch(() => {});
    },
    //发送消息学生
    sendMessage(id) {
      this.$refs.sendMessageDialogRef.open(id);
      // this.$message.info(`发送消息学生学生${id}`);
    },
    //设置倒计时
    setCountDown() {
      if (this.countDownTimeValue)
        return this.$message.info(this.lang.pleaseWaitCurrentCountdownEnd);
      this.$refs.countdownDialogRef.open();
    },
    //打开用户对话弹窗
    openStudentDialog(id, index) {
      let _data = this.copyStudentList.find((i) => i.id === id).nodeData[index];
      this.$refs.studentDialogueDataDialogRef.open(_data);
    },
    openStudentAllMessageDialog(id) {
      // console.log("测试测试",id)

      let _data = [];
      this.copyStudentList
        .find((i) => i.id === id)
        .nodeData.map((i) => i)
        .forEach((i) => {
          i.messageList.forEach((i2) => {
            _data.push(i2);
          });
        });
      this.$refs.studentDialogueDataDialogRef.open({ messageList: _data });
    },
    getClassList() {
      let params = {
        idList: this.obj.class_id,
      };
      this.ajax
        .get(this.$store.state.api + "select_ClassByidList", params)
        .then((res) => {
          let _result = res.data[0];
          if (_result.length > 0) {
            let list = [];
            list.push({ value: "", label: this.lang.all_classes });
            _result.forEach((item) => {
              list.push({ value: item.id, label: item.name });
            });

            this.selectClassList = list;
          }
        })
        .catch((err) => {
          console.log("获取班级失败", err);
        });
    },
    getStudentList() {
      if (this.loading) return;
      this.loading = true;

      if (!this.obj.id) return (this.loading = false);
      let params = {
        uid: this.user.userId,
        tid: this.obj.id,
        sid: "",
      };

      this.ajax
        .get(this.$store.state.api + "select_teachingModeWorks", params)
        .then((res) => {
          let _result = res.data[0];
          if (_result.length > 0) {
            _result.forEach((i) => {
              //i.summary = i.summary ? JSON.parse(i.summary) : "";
              i.nodeData = i.nodeData ? JSON.parse(i.nodeData) : [];
            });

            this.copyStudentList = _result;
          } else {
            this.copyStudentList = [];
          }
          this.changeSelect();
          this.$forceUpdate();
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateStudentData(id, tid) {
      console.log(id, tid);
      if (
        this.copyStudentList.some((i) => i.id === id) ||
        this.obj.id === tid
      ) {
        let params = {
          uid: this.user.userId,
          tid: this.obj.id,
          sid: id,
        };
        this.ajax
          .get(this.$store.state.api + "select_teachingModeWorks", params)
          .then((res) => {
            let _result = res.data[0];
            if (_result.length > 0) {
              let _data = _result[0];
              //_data.summary = _data.summary ? JSON.parse(_data.summary) : "";
              _data.nodeData = _data.nodeData ? JSON.parse(_data.nodeData) : [];
              let _updateIndex = this.copyStudentList.findIndex(
                (i) => i.id === _data.id
              );
              console.log("👉xxx", _updateIndex, tid, this.obj, _data);
              if (_updateIndex != -1) {
                this.copyStudentList[_updateIndex] = _data;
              } else if (this.obj.id === _data.tid) {
                this.copyStudentList.push(_data);
              }
              this.changeSelect();
              this.$forceUpdate();
            }
          })
          .catch((err) => {
            console.log("更新学生数据失败", err);
          });
      }
    },
    //发送消息
    sendMessageSuccess({ msg, id }) {
      this.$emit("sendMessage", {
        type: "sendMessageToStudent",
        msg: msg,
        sid: id,
        id: this.obj.id,
      });

      this.$refs.sendMessageDialogRef.close();
      this.$message.success(this.lang.send_a_message + this.lang.succeed);
    },
    //发送倒计时
    sendCountDownSuccess({ time, msg }) {
      this.$emit("sendMessage", {
        type: "sendCountDownToStudent",
        msg: msg,
        time: time,
        id: this.obj.id,
      });

      let _nowTime = new Date().getTime();

      let _time = parseInt(time) * 60 * 1000;
      let _timer = setInterval(() => {
        this.countDownTimeValue = this.countDownTimeText(
          (_nowTime + _time - new Date().getTime()) / 1000
        );
        // console.log("倒计时时间",_timeText)
        if (_nowTime + _time <= new Date().getTime()) {
          this.countDownTimeValue = "";
          clearInterval(_timer);
        }
      }, 1000);
      this.$refs.countdownDialogRef.close();
      this.$message.success(
        this.lang.fs + this.lang.Timer + this.lang.succeed
      );
    },
    //移除学生
    delStudent(id) {
      this.$confirm(this.lang.confirmDeleteApp, this.lang.tip, {
        confirmButtonText: this.lang.queding,
        cancelButtonText: this.lang.cancel,
        type: "warning",
      })
        .then(() => {
          let params = [
            {
              uid: this.user.userId,
              wid: id,
            },
          ];

          this.ajax
            .post(
              this.$store.state.api + "delete_teachingModeWorksById",
              params
            )
            .then((res) => {
              if (res.data == 1) {
                this.$message.success(this.lang.deleteStudentSuccess);
              } else {
                this.$message.error(this.lang.deleteStudentFail);
              }
              this.getStudentList();
            })
            .catch((err) => {
              console.log(err);
              this.$message.error(this.lang.deleteStudentFail);
            });
        })
        .catch(() => {});
    },
    getLang(){
      let lang = 'cn'
      if(this.lang.lang == 'cn'){
        lang = 'Chinese.'
      }else if(this.lang.lang == 'hk'){
        lang = 'Traditional Chinese.'
      }else if(this.lang.lang == 'en'){
        lang = 'English.'
      }
      return lang
    },
    //ai分组
    groupingBtn(_data) {
      return new Promise((resolve) => {
        if (this.getGroupListLoading) return resolve(false);
        this.getGroupListLoading = true;
        let studentList = JSON.parse(JSON.stringify(_data));

        let messageText = ``;

        studentList.forEach((s) => {
          messageText += `学生：${s.name}\n总结：${s.summary}\n总节点数量：${
            s.stage
          }\n任务状态：${this.statusList[s.status]}\nID：${s.id}\n`;
          s.nodeData.forEach((n, nIndex) => {
            messageText += `【节点${(nIndex + 1).toString().padStart(2, "0")} ${
              n.messageList[0] ? n.messageList[0].aiName : "-"
            }】表情：${
              n.status == "0" ? "微笑" : n.status == "1" ? "不高兴" : "无表情"
            }\n`;
            n.messageList.forEach((m) => {
              messageText += `${m.userName}(${m.chatTime})：\n${m.userContent}\n${m.aiName}：\n${m.aiContent}\n`;
            });
          });
          messageText += "\n";
        });

        let _msg = `你是一个学习分组专家，负责根据学生在AI学习工作流中的表现将学生分为3组。严格按照输出格式输出，不要输出其他内容。

**输入信息：**
${messageText}
**分组策略：**
基于概念理解程度和学习参与度进行三维分组：
1. **理解程度**：概念掌握清晰，回答正确 vs 部分理解 vs 理解困难
2. **参与态度**：积极主动 vs 一般配合 vs 消极抵触  
3. **学习进度**：快速完成 vs 正常节奏 vs 需要支持

**分组标准：**
- **第一组**：理解好+参与积极，或理解一般但非常积极
- **第二组**：理解和参与都处于中等水平
- **第三组**：理解困难+参与消极，或严重的单一问题


**组名要求：**
- 4个字的正面激励短语；避免负面标签的表述

**示例输出：**
【快速掌握】
- 理解透彻参与积极，可承担更高难度挑战 
- 学生列表：张三、李四、王五
【稳步前进】
- 基础理解良好，需要适当引导和练习巩固
- 学生列表：赵六、钱七、孙八
【重点关注】
- 概念理解较为薄弱，需要更多支持和鼓励 
- 学生列表：周九、吴十、郑十一

***输出要求***
输出内容里的list不需要有学生姓名，只需要有输入信息的学生ID,不要有其他内容,没有就为空
如果无内容就只输出 []

**输出格式：**
[{"groupName":"分组名称","list":["ID","ID"],"bgColor":"背景颜色","color":"字体颜色","borderColor":"边框颜色"},{"groupName":"分组名称","list":["ID","ID"],"bgColor":"背景颜色","color":"字体颜色","borderColor":"边框颜色"},{"groupName":"分组名称","list":["ID","ID"],"bgColor":"背景颜色","color":"字体颜色","borderColor":"边框颜色"},{"groupName":"分组名称","list":["ID","ID"],"bgColor":"背景颜色","color":"字体颜色","borderColor":"边框颜色"}]
`;

        let message = [{ role: "user", content: _msg }];

        this.chat_no_stream(message).then((res) => {
          try {
            if (res) {
              let _group = JSON.parse(res);
              // let _json = JSON.parse(JSON.stringify(this.obj.tJson));
              // if (_json === "") _json = {};
              // _json.group = _group;
              // this.$parent.updateTeachingModeJson(_json);
              // if (
              // 	this.selectGroupingList.findIndex(
              // 		(i) => i.value === "aiGroupList"
              // 	) === -1
              // ) {
              // 	this.selectGroupingList.push({
              // 		value: "aiGroupList",
              // 		label: this.lang.aiGroupList,
              // 		group: _group,
              // 	});
              // } else {
              // 	this.selectGroupingList.find(
              // 		(i) => i.value === "aiGroupList"
              // 	).group = _group;
              // }
              let _isUseData = [];
              _group.forEach((i) => {
                i.list.forEach((i2, index2) => {
                  let _findIndex = _data.findIndex((i3) => i3.id == i2);
                  if (_findIndex != -1) {
                    i.list[index2] = _data[_findIndex];
                    _isUseData.push(_data[_findIndex].id);
                  } else {
                    i.list.splice(index2, 1);
                  }
                });
              });
              this.selectGrouping = "1";
              // this.changeSelect();
              // this.groupStudentList = _group;
              this.getGroupListLoading = false;
              resolve(_group);
              // this.$message.success(this.lang.getGroupSuccess);
            } else {
              this.$message.error(this.lang.getGroupFail);
              this.getGroupListLoading = false;
              resolve(false);
            }
          } catch (error) {
            console.log(error);
            this.$message.error(this.lang.getGroupFail);
            this.getGroupListLoading = false;
            resolve(false);
          }
        });
      });
    },
    inviteStudent() {
      this.$parent.invitationBtn();
    },
    //发送消息分组
    sendMessageToGroup(list) {
      let _idList = list.map((i) => i.id).join(",");
      this.$refs.sendMessageDialogRef.open(_idList);
      // this.$refs.sendMessageDialogRef.open(list);
    },
    //倒计时文本
    countDownTimeText(time) {
      let _minute = Math.floor(time / 60);
      let _second = Math.floor(time % 60);
      return `${_minute.toString().padStart(2, "0")}:${_second
        .toString()
        .padStart(2, "0")}`;
    },
    showDiagnosisReport(item) {
      if (!this.isShowTest) return false;
      if (!item || item.status !== "1") return false;
      const node = this.getLatestNode(item);
      return !!(
        node &&
        Array.isArray(node.messageList) &&
        node.messageList.length
      );
    },
    getLatestNode(item) {
      if (!item || !Array.isArray(item.nodeData) || !item.nodeData.length)
        return null;
      return item.nodeData[item.nodeData.length - 1];
    },
    // 智能总结
    smartSummary(item) {
      return new Promise((resolve)=>{
        if (this.smartSummaryLoadingList.includes(item.id)) return resolve(false);
      this.smartSummaryLoadingList.push(item.id);
      const nodeData = item.nodeData;

      let messageText = "";
      nodeData.forEach((item, index) => {
        let chatText = "";
        messageText += `【节点${(index + 1).toString().padStart(2, "0")}${
          item.messageList[0].aiName
        }】表情：${
          item.status === "0"
            ? "微笑"
            : item.status === "1"
            ? "不高兴"
            : "无表情"
        }\n`;
        item.messageList.forEach((detail) => {
          chatText += `学生-${detail.userName}(${detail.chatTime})：\n${detail.userContent}\n${detail.aiName}：\n${detail.aiContent}\n`;
        });
        messageText += `${chatText}\n`;
      });
      const msg = `你是一个学科学习进度总结专家，负责分析学生在特定学科AI学习工作流中的综合表现。

**输入信息：**
${messageText}

**分析维度：**
1. **学科理解程度**：对需要理解的核心概念的掌握情况
  物理：实验理解、概念建构、公式应用
  数学：逻辑推理、解题思路、计算准确性
  语文：文本理解、表达能力、思维深度

2. **学习工作流适应性**：对AI引导学习模式的接受度
  能否跟上节点设计的学习节奏
  是否理解每个环节的学习目标

3. **知识建构过程**：从概念引入到应用的学习轨迹
  前置知识激活情况
  新知识接受和整合能力

4. **学习困难定位**：具体卡在哪个知识点或学习环节

**输出格式：**
一句话总结，15-25个字，包含：
理解水平 + 主要问题/优势 + 建议关注点

**示例输出：**
"密度概念理解困难，实验参与度低，需加强学习"
"数学逻辑清晰，解题步骤完整，可适当增加难度"
"文本理解较好，表达欠缺，需要多增加完整表述"
"实验兴趣高，理论联系实际能力待提升"`;

      const message = [{ role: "user", content: msg }];
      this.chat_no_stream(message).then((res) => {
        this.smartSummaryLoadingList = this.smartSummaryLoadingList.filter(
          (i) => i != item.id
        );
        this.updateStudentSummary(res, item.id).then(res=>{
          resolve(res)
        });
      })
      })
    },
    //修改学生总结
    updateStudentSummary(text, sid) {
      return new Promise((resolve)=>{
        const params = [
        {
          wid: sid,
          summary: text,
        },
      ];
      this.ajax
        .post(
          this.$store.state.api + "update_teachingModeWorks_summaryById",
          params
        )
        .then((res) => {
          const data = res.data;
          if (data === 1) {
            this.updateStudentData(sid, this.obj.id);
            resolve(true)
            console.log("修改学生总结成功");
            // this.teachingModeWorksData.summary = text;
            // this.sendYMessage({
            //   type: 'changeTeachingWorks',
            //   id: this.teachingModeWorksData.id,
            //   tid: this.teachingModeData.id,
            // });
          } else {
            resolve(false)
            console.log("修改学生总结失败", res);
          }
        });
      })
    },
    smartSummaryList(){
      this.$confirm(this.lang.smartSummaryConfirm,this.lang.tip,{
        confirmButtonText:this.lang.confirm,
        cancelButtonText:this.lang.cancel,
      }).then(()=>{
        let _data = JSON.parse(JSON.stringify(this.studentList))
        if(!['agent'].includes(this.obj.label)){
          _data = _data.filter((item)=>item.status === '1')
        }

        let promise = []
        _data.forEach((item)=>{
          promise.push(this.smartSummary(item))
        })

        Promise.all(promise).then(()=>{
          this.$message.success(this.lang.smartSummarySuccess)
        })
      })
    },

  },
  mounted() {
    this.getClassList();
    this.getStudentList();
  },
};
</script>

<style lang="scss" scoped>
.studentCard {
  width: 100%;
  height: auto;
  padding-bottom: 30px;
  overflow-x: hidden;
  .sc_header {
    width: 100%;
    height: 50px;
    margin: 15px 0;
    display: flex;
    justify-content: space-between;
    .sc_h_left {
      width: auto;
      display: flex;
      align-items: center;
      .sc_h_l_input {
        width: 200px;
      }
    }
    .sc_h_right {
      display: flex;
      align-items: center;
      div {
        padding: 5px 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        border-radius: 20px;
        margin-left: 15px;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
        cursor: pointer;
        transition: 0.2s;
        color: #000;
        &:hover {
          background-color: #3681fc !important;
          color: #fff !important;
          svg {
            fill: #fff !important;
          }
          .messageSvg {
            stroke: #fff !important;
            fill: #3681fc !important;
          }
        }
        svg {
          width: 20px;
          height: 20px;
          margin-right: 5px;
          transition: 0.2s;
        }
      }
    }
  }
  .sc_tableArea {
    width: 100%;
    min-height: calc(100% - 50px - 30px);
    box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.05);
    border-radius: 12px;
    .sc_ta_header {
      width: 100%;
      height: 56px;
      border-radius: 12px 12px 0 0;
      background-color: #fff;
      box-sizing: border-box;
      border-bottom: solid 1px #bdbdbd;
      padding: 0 50px;
      .sc_ta_h_item {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &>span {
          display: flex;
          flex: 1;
          height: 100%;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          // color: #969ba3;
          color: #00000099;
          text-align: center;
          gap: 10px;
          img{
            width: 12px;
            height: 12px;
            cursor: pointer;
          }
          &:nth-child(1) {
            justify-content: flex-start;
            // color: #000;
          }
          &:nth-last-of-type(1) {
            justify-content: flex-end;
            flex: 0.5;
          }
        }
      }
    }
    .sc_ta_box {
      width: 100%;
      height: calc(100% - 56px);
      background-color: #fcfbfb;
      border-radius: 0 0 12px 12px;
      box-sizing: border-box;
      overflow: auto;
      box-sizing: border-box;
      // padding: 0 30px;
      .sc_ta_b_item {
        width: 100%;
        height: 100px;
        display: flex;
        align-items: center;
        border-bottom: solid 1px #e7e7e7;
        cursor: pointer;
        box-sizing: border-box;
        padding: 0 30px;
        transition: 0.2s;
        &:hover {
          background-color: #fff;
          // border-color: #eaeaea;
        }
        & > div {
          width: 100%;
          position: relative;
          height: 100px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-radius: 10px;
          // border: 1px solid #fcfbfb;
          padding: 0 20px;
          transition: 0.1s;

          & > div {
            display: flex;
            flex: 1;
            height: 100%;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            position: relative;
            color: #000;
            &:nth-child(1) {
              justify-content: flex-start;
              font-weight: bold;
            }
            &:nth-last-of-type(1) {
              justify-content: flex-end;
              flex: 0.5;
              svg {
                width: 30px;
                height: 30px;
                cursor: pointer;
                transition: 0.3s;
                &:hover {
                  fill: #3681fc !important;
                }
              }
            }
            .collaboration {
              padding: 2px 10px;
              background-color: none;
              margin-left: 10px;
              border: dashed 1px #000;
              border-radius: 20px;
              font-size: 14px;
              cursor: default;
            }
            .taskStatus {
              padding: 4px 20px;
              border-radius: 20px;
              font-size: 14px;
              border: solid 1px #fff;
            }
            .taskStatus_1 {
              background-color: #effcf5;
              color: #17c469;
              border-color: #d1f6a0;
            }
            .taskStatus_0,
            .taskStatus_2,
            .taskStatus_3 {
              background-color: #f3f3f3;
              color: rgba(0, 0, 0, 0.4);
              border-color: #d5deeb;
            }
            .status {
              width: 8px;
              height: 8px;
              border-radius: 10px;
              position: absolute;
              top: 8px;
              left: -6px;
            }
            .status_0 {
              background-color: #d9d9d9;
            }
            .status_1 {
              background-color: #bce685;
            }
            .status_2 {
              background-color: #f06643;
            }
            .nodeStage {
              width: 100%;
              height: 10px;
              position: absolute;
              left: 0;
              bottom: 10px;
              display: flex;
              span {
                width: 8px;
                height: 8px;
                border-radius: 10px;
                background-color: #d9d9d9;
                box-sizing: border-box;
                border: dashed 1px #000;
                margin-right: 3px;
              }
              .ns_active {
                background-color: #3681fc;
                border-color: #3681fc;
              }
            }
            .summaryText {
              display: -webkit-box;
              width: 100%;
              max-width: 260px;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              white-space: normal;
              text-align: center;
            }
            .nodeArea {
              width: auto;
              height: auto;
              overflow: hidden;
              display: flex;
              &:hover {
                overflow: auto;
              }
              .na_item {
                width: 30px;
                min-width: 30px;
                height: 60px;
                display: inline-flex;
                margin: auto 10px;
                border-radius: 20px;
                box-sizing: border-box;
                border: dashed 1px #969ba3;
                position: relative;
                flex-direction: column;
                justify-content: space-around;
                align-items: center;
                color: #969ba3;
              }
              .nodeBar::after {
                content: "";
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                right: -16px;
                width: 10px;
                height: 2px;
                border-radius: 10%;
                background-color: #969ba3;
              }
            }
            .diagnosis-report-icon {
              width: 40px;
              height: 60px;
              // border: 1px dashed #969ba3;
              border-radius: 20px;
              display: flex;
              align-items: center;
              justify-content: center;
              // color: #969ba3;
              transition: 0.2s;
              color: #3681fc;
            }
            .diagnosis-report-icon:hover {
              color: #3681fc;
            }
          }
        }
      }
    }
  }
}

.na_message {
  width: 500px;
  max-height: 70vh;
  padding-right: 10px;
  overflow: auto;
  .na_m_item {
    width: 100%;
    height: auto;
    margin: 10px 0;
    .na_m_i_name {
      width: fit-content;
      max-width: 100%;
      height: auto;
      box-sizing: border-box;
      padding: 5px 10px;
      // display: flex;
      // align-items: center;
      border-radius: 10px 10px 0 0;
      background-color: #9747ff;
      color: #fff;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .aiName {
      background-color: #0560fc;
    }
    .na_m_i_content {
      padding: 10px;
      border: solid 1px #e7e7e7;
      box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.1);
      border-radius: 0 0 12px 12px;
    }
  }
}

.teachingModePopoverArea {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: fit-content;
  width: fit-content;
  height: auto;
}

.teachingModePopoverAreaBtn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 40px);
  padding: 1px 20px;
  height: 30px;
  font-size: 16px;
  border-radius: 8px;
  transition: 0.1s;
  margin: 5px 0;
}

.teachingModePopoverAreaBtn:hover {
  background-color: #f2f4f7;
  // color: #fff;
  cursor: pointer;
}

.noData {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.groupHead {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.gh_name {
  width: auto;
  height: auto;
  padding: 8px 40px;
  display: block;
  background: #fff;
  border-radius: 20px 20px 0 0;
}

.inviteStudent {
  // margin-left: 10px;
  color: #007aff;
  cursor: pointer;
  text-decoration: underline;
}

.noDataText {
  display: flex;
  flex-direction: column;
  // align-items: flex-start;
}

.messageBtn {
  padding: 5px 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 20px;
  margin-left: 15px;
  margin-bottom: 10px;
  margin-right: 10px;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: 0.2s;
  color: #000;
  &:hover {
    background-color: #3681fc !important;
    color: #fff !important;
    svg {
      fill: #fff !important;
    }
    .messageSvg {
      stroke: #fff !important;
      fill: #3681fc !important;
    }
  }
  svg {
    width: 20px;
    height: 20px;
    margin-right: 5px;
    transition: 0.1s;
  }
}

.na_m_i_content :deep(p img) {
  max-width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}
</style>
